// @ts-nocheck
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateAdditionalApiParameter = createChainHandler("PopulateAdditionalApiParameter", chain, props => {
    const state = props.getState().components.contactUsForm;
    const greifState = props.getState().greif.pages.contactUs;
    props.apiParameter = {
        ...props.apiParameter,
        properties: {
            userCompany: state.fieldValues["userCompany"],
            userSelectedPlant: greifState.plantFieldValues.plantDisplayName,
            customerServiceRepresentativeEmail: greifState.plantFieldValues.email,
            shipTo: greifState.shipTo || greifState.customerNumber || undefined,
            soldTo: greifState.soldTo || undefined,
            billingAddress: greifState.billingAddress || undefined,
        },
    };
});

addToChainAfter(chain, PopulateApiParameter, PopulateAdditionalApiParameter);
